export const formatTransaction = (transaction) => {
    return `$${Math.abs(transaction.amount).toFixed(2)} on ${new Date(
        transaction.date,
    ).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })} from ${
        transaction.vendor || transaction.description
    } (x${transaction.card_last4}) ${transaction.bank_name ?? ''}`;
};

export const formatInventory = (inventory) => {
    return `${inventory.description}, ${inventory.class_1}, ${inventory.class_2}, Seats ${
        inventory.seats
    } | ${new Date(inventory.purchased_at).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    })} | $${inventory.purchase_price.toFixed(2)} | ${inventory.purchase_email || 'No email'} ${
        inventory.reference_id ? `| ${inventory.reference_id}` : ''
    }`;
};

export const getGeneratedReasoning = (cardData) => {
    return ``;
};
